import React from 'react';
import {Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import NewCampaignButton from '@/components/new-campaign-button';
import styles from './CampaignsListHeader.module.scss';

export default function CampaignsListHeader() {
  return (
    <div className={styles.header}>
      <Headline size="lg" className={styles.title}>
        {translate('Campaigns')}
      </Headline>
      {/* Slot keeps the button at its natural width inside the flex header.
          The shared NewCampaignButton wrapper has `width: 100%` which, without
          this slot, makes the wrapper greedily fill remaining space and
          centers the button mid-row instead of right-aligning it. */}
      <div className={styles.buttonSlot}>
        <NewCampaignButton label={translate('New Campaign')} />
      </div>
    </div>
  );
}
